import{e as n,m as r}from"./chunk-HBP5N4FR.js";function l(e){for(let t=0;t<e.length;t++)if(e.charCodeAt(t)>127)return!1;return!0}var f=n(()=>{r()});export{l as a,f as b};
//# sourceMappingURL=chunk-SAQ2TZS4.js.map
